import { v4 as uuid } from "uuid";
import * as UserConst from "actions/userConst";
import { useSelector, useDispatch } from 'react-redux'

import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk, current } from '@reduxjs/toolkit'
import TenantAPI from "@/api/TenantAPI";

import {TENANT} from "@/actions/globalConst";

import DB from "@/models/DB";
import { TenantModel } from "@/models/PPC/Tenant";
import { CompanyModel } from "@/models/PPC/Company";

import { TenantCompanyModel } from "@/models/Tenant";
import { WorkhoursModel } from "@/models/Workhours/Workhours";
import { Sector } from "@/models/Sector";
import { FieldTypesModel } from "@/models/PPC/FieldTypes";

export const initialState = {
  status: TENANT.INIT,
    view: TENANT.VIEW_OVERVIEW,
    apiState: TENANT.API_INIT,
  tenants: false,
  selected: new CompanyModel(),
  companyModel: null,
  externTenants: [],
  key: "",
  lastAuthCode: null,
  settings: {
    fieldtypes: null,
    workhours: null,
    event_types: null,
    sectors: null,
    priority: null,
    tenant: null,
    
  }
};



export const addTenant = createAsyncThunk(
  TENANT.ADD,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await TenantAPI.saveTenant(data);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const deleteTenant = createAsyncThunk(
  TENANT.API_DELETE,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await TenantAPI.deleteTenant(data.tenantKey);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const tenantNew = createAsyncThunk(TENANT.VIEW_NEW, async (data, event) => {
    let response = null;
    try {
          response = await TenantAPI.getNewTenantForSuperuser(data, event.getState().TenantReducer.status == TENANT.INIT);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const tenantEdit = createAsyncThunk(TENANT.VIEW_DETAIL, async (data, event) => {
    let response = null;
    try {
          response = await TenantAPI.getTenantForSuperuser(data, event.getState().TenantReducer.status == TENANT.INIT);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const tenantoverview = createAsyncThunk(TENANT.VIEW_OVERVIEW, async (data, event) => {
    let response = null;
    try {
          response = await TenantAPI.getAllForSuperuser()
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const authoriseDropBoxWithCode = createAsyncThunk(
    TENANT.API_AUTHORISE_DROPBOX_WITH_CODE, 
    async (data:any, event) => {
        let response = null;
        try {
          response = await TenantAPI.dropboxAuthoriseWithCode(data.tenantKey, data.dropboxCode)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  })

  export const updateDropbox = createAsyncThunk(
      TENANT.API_UPDATE_DROPBOX, 
      async (data:any, event) => {
          let response = null;
          try {
            response = await TenantAPI.updateDropboxAccount(data.tenantKey, data.data)
          } catch (err) {
              return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
          }
      return response.data;
    })
  
  
export const disconnectDropboxAccount = createAsyncThunk(
    TENANT.API_DISCONNECT_DROPBOX_ACCOUNT, 
    async (data, event) => {
        let response = null;
        try {
          response = await TenantAPI.disconnectDropboxAccount(data.tenantKey)
        } catch (err) {
            return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
        }
    return response.data;
  })

          const fullFilledEventHandler = (data = null, state) => {
              if(!data) {
  //                state = {...initialState} 
              } else {
                    if(data.workhours) {
                        state.settings.workhours = DB.newCollection(data.workhours, WorkhoursModel);
                    }
                    if(data.event_types) {
                        state.settings.event_types = data.event_types;
                    }
                    if(data.sectors) {
                        state.settings.sectors = DB.newCollection(data.sectors, Sector);
                    }
                    if(data.priority) {
                        state.settings.priority = data.priority;
                    }
                        if(data.fieldtypes) {
                            state.settings.fieldtypes = DB.newCollection(data.fieldtypes, FieldTypesModel); //new TenantModel(data.tenant); // DB.newModel(data.tenant, TenantModel);
                        }
                    if(data.tenant) {
                        state.settings.tenant = DB.newModel(data.tenant, TenantModel); //new TenantModel(data.tenant); // DB.newModel(data.tenant, TenantModel);
                        if(state.settings.tenant && state.settings.tenant?.company) {
                            state.selected = state.settings.tenant.company;
                        } 
                    }
              }
              return state;
           }

const TenantReducer = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    // omit existing reducers here
      newTenant(state, action) {
          state.selected = new CompanyModel();
      },
      cancel(state, action) {
          state.selected = new CompanyModel();
          state.apiState = TENANT.API_READY;
          state.view = TENANT.VIEW_OVERVIEW;
      }
    
  },
  extraReducers(builder) {
     builder.addCase(addTenant.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array
      state.status = UserConst.USER_STATE_IDLE
      state.view = TENANT.VIEW_OVERVIEW;
        state.interests = action.payload.data.data;
        state.user_interests = action.payload.data.user_interest;
        state.key = uuid().slice(0, 8);
    })      
    .addCase(addTenant.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR
        state.error = action.payload;
        
      })
    builder.addCase(deleteTenant.fulfilled, (state, action) => {
        if(action.payload.data.tenants) {
         state.tenants = action.payload.data.tenants;
        }
          //state.selected = new TenantCompanyModel();
        state.apiState = TENANT.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(deleteTenant.rejected, (state, action) => {
        state.apiState = TENANT.API_READY;
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(deleteTenant.pending, (state, action) => {
        state.apiState = TENANT.API_PROCESSING;
    });

    builder.addCase(tenantoverview.fulfilled, (state, action) => {
        if(action.payload.data.tenants) {
         state.tenants = action.payload.data.tenants;
        }
          //state.selected = new CompanyModel();
        state.apiState = TENANT.API_READY;
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(tenantoverview.rejected, (state, action) => {
        state.apiState = TENANT.API_READY;
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(tenantoverview.pending, (state, action) => {
        state.apiState = TENANT.API_PROCESSING;
    });

    builder.addCase(tenantEdit.fulfilled, (state, action) => {
        fullFilledEventHandler(action.payload.data, state);
        if(action.payload.data.tenant) {
//            state.selected = new TenantCompanyModel(action.payload.data.tenant.company, action.payload.data.tenant);
            }
        if(action.payload.data.tenant) {
//            state.selected = new TenantCompanyModel(action.payload.data.tenant.company, action.payload.data.tenant);
            }
            if(action.payload.data.externTenants) {
                state.externTenants = action.payload.data.externTenants;
            } 
            
        if(action.payload.data.tenants) {
         state.tenants = action.payload.data.tenants;
        }
            
        state.apiState = TENANT.API_READY;
        state.view = TENANT.VIEW_EDIT,
      state.key = uuid().slice(0, 8);
      state.error = null;
        console.debug("COMPANY MODEl111", current(state) ); 
    }).addCase(tenantEdit.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(tenantEdit.pending, (state, action) => {
        state.apiState = TENANT.API_PROCESSING;
    });

    builder.addCase(tenantNew.fulfilled, (state, action) => {
        fullFilledEventHandler(action.payload.data, state);
        if(action.payload.data.tenant) {
            //state.selected = new CompanyModel(action.payload.data.tenant.company, action.payload.data.tenant);
            }
        if(action.payload.data.tenants) {
         state.tenants = action.payload.data.tenants;
        }
        if(action.payload.data.externTenants) {
            state.externTenants = action.payload.data.externTenants;
        } 

        state.apiState = TENANT.API_READY;
        state.view = TENANT.VIEW_EDIT,
      state.key = uuid().slice(0, 8);
      state.error = null;
    }).addCase(tenantNew.rejected, (state, action) => {
        state.error = action.payload;
        state.key = uuid().slice(0, 8);
    }).addCase(tenantNew.pending, (state, action) => {
        state.apiState = TENANT.API_PROCESSING;
    });




      builder.addCase(authoriseDropBoxWithCode.fulfilled, (state, action) => {
            state.api_state = TENANT.API_READY;
            state.view = TENANT.VIEW_EDIT;
            //state.selected = new TenantCompanyModel(action.payload.data.tenant.company, action.payload.data.tenant);
//            if(action.payload.data.dropboxSettings) {
//                state.dropbox = action.payload.data.dropboxSettings;
//            }
            state.key = uuid().slice(0, 8);
      }).addCase(authoriseDropBoxWithCode.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(authoriseDropBoxWithCode.pending,(state, action) => {
        state.apiState = TENANT.API_PROCESSING;
      });

      builder.addCase(disconnectDropboxAccount.fulfilled, (state, action) => {
        state.api_state = SETTINGS.API_READY;
        if(action.payload.data.dropboxSettings) {
            state.dropbox = action.payload.data.dropboxSettings;
        }
        state.key = uuid().slice(0, 8);
          
      }).addCase(disconnectDropboxAccount.rejected, (state, action) => {
          //    state.api_state = SETTINGS.API_E;
      }).addCase(disconnectDropboxAccount.pending,(state, action) => {
        state.api_state = SETTINGS.API_PENDING;
      });

      builder.addMatcher(
        (action) => action.type == "switchtenant/pending",
        (state, action) => {
          state.settings = {...initialState.settings};
            
         })

         builder.addMatcher(
           (action) => action.type == "switchtenant/fulfilled",
           (state, action) => {
            
             fullFilledEventHandler(action?.payload?.data, state);
               
            })
      
            builder.addMatcher(
              (action) => action.type == "USER_CHECKAUTH/fulfilled",
              (state, action) => {
               
                fullFilledEventHandler(action?.payload?.data.data, state);
                  
               })
      
  }
});
//export const { unsetSelected } = TenantReducer.actions;
export const { cancel, newTenant } = TenantReducer.actions;

export default TenantReducer.reducer;